import { TtOption } from './TtOption.js';

if (typeof window !== 'undefined') {
  if (!window.customElements.get('tt-option')) {
    window.customElements.define('tt-option', TtOption);
  }
}

export { TtOption };
